<template>
  <div class="summary-table-wrapper">
    <slot />
  </div>
</template>
<style lang="scss">
.summary-table-wrapper {
  .q-table__container > .q-table__middle > .q-table > thead > tr > .text-left {
    padding: 7px 0 !important;
    font-weight: bold;
    font-size: $sub-header;
    border: none;
  }

  .q-table__container > .q-table__middle > .q-table > tbody > tr > td:before {
    border-radius: 6px;
  }

  .q-table__container > .q-table__middle > .q-table > tbody > tr > .text-left {
    cursor: default;
  }

  .q-table__container > .q-table__middle > .q-table > tbody > tr > .q-td {
    padding: 0 !important;
    cursor: default;
    border: none;
    height: unset;
  }

  .q-table__container > .q-table__middle > .q-table {
    border-spacing: 0px $space-sm;
  }

  .q-table__container > .q-table__bottom > .q-table__separator {
    display: none;
  }

  .q-table__container > .q-table__bottom {
    justify-content: center;
    font-size: 12px;
    border: none;
  }

  .q-table__container > .q-table__top {
    display: none;
  }
}
</style>
